import { ForwardedRef, forwardRef, useState } from 'react';
import { IMaskMixin } from 'react-imask';

import Input, { IInputProps } from '../input';

export interface MaskedInputInterface extends Omit<IInputProps, 'value'> {
  mask?: string;
  replacement?: { [key: string]: RegExp };
  value?: string;
  inputRef?: ForwardedRef<HTMLInputElement>;
  definitions?: { [key: string]: RegExp };
  overwrite?: boolean;
  unmask?: boolean;
  lazy?: boolean;
  onAccept?: (value: string) => void;
}

// Создаём компонент с маской через IMaskMixin
const MaskedInputComponent = IMaskMixin<HTMLInputElement, MaskedInputInterface>(
  ({ inputRef, ...props }) => {
    return <Input ref={inputRef} {...props} />;
  }
);

// Оборачиваем в forwardRef для поддержки forwardedRef
const MaskedInput = forwardRef<HTMLInputElement, MaskedInputInterface>(
  ({ mask = '', replacement, value, onChange, ...props }, forwardedRef) => {
    const [showMask, setShowMask] = useState(() => false);

    return (
      <MaskedInputComponent
        inputRef={forwardedRef}
        mask={mask}
        value={value}
        definitions={replacement || { _: /\d/ }}
        unmask={false}
        lazy={!showMask}
        onAccept={(value: string) => {
          onChange?.({
            target: { value }
          } as React.ChangeEvent<HTMLInputElement>);
        }}
        {...props}
        onFocus={(e) => {
          setShowMask(true);
          props.onFocus?.(e);
        }}
        onBlur={(e) => {
          if (value === mask) {
            onChange?.({
              target: { value: '' }
            } as React.ChangeEvent<HTMLInputElement>);
          }
          props.onBlur?.(e);
          setShowMask(false);
        }}
      />
    );
  }
);

MaskedInput.displayName = 'MaskedInput';

export default MaskedInput;
